{
  "Target1Label": "Alvo 1:",
  "Target1Placeholder": "15",
  "Target2Label": "Alvo 2:",
  "Target2Placeholder": "30",
  "Target3Label": "Alvo 3:",
  "Target3Placeholder": "60",
  "Target4Label": "Meta 4:",
  "Target4Placeholder": "90",
  "Target5Label": "Meta 5:",
  "Target5Placeholder": "120",
  "Target6Label": "Meta 6:",
  "Target6Placeholder": "300",
  "TargetUnit": "s",
  "ResetanswertargetsButtonLabel": "Redefinir metas de resposta",
  "ResetanswertargetsPrompt": "Tem certeza de que deseja redefinir todas as 6 configurações de limite de duração de atendimento de chamadas de entrada para seus valores padrão?",
  "ResetanswertargetsPromptButtonConfirmLabel": "confirme",
  "ResetanswertargetsPromptButtonCancelLabel": "Cancelar",
  "AnswerPerformance_SectionHeader": "Desempenho de respostas",
  "AnswerPerformance_SectionPara": "Você também pode ajustar especificamente o(s) limite(s) de duração de resposta de destino, que são usados pelas sete variantes de estatísticas de desempenho de resposta de entrada do estilo \"Respostas < = Xs\".",
  "NAME": "AnswerPerformance"
}